import API from "./axios";

// ===== AGENT WALLET APIs =====

// Get current wallet balance
export const getWalletBalance = async () => {
  try {
    const response = await API.get('wallet/agent/balance');
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to fetch wallet balance';
  }
};

// Get transaction history with pagination and filters
export const getWalletTransactions = async (page = 1, limit = 10, filters = {}) => {
  try {
    const { searchTerm, transactionType, startDate, endDate } = filters;
    const params = new URLSearchParams({
      page,
      limit,
      ...(searchTerm && { searchTerm }),
      ...(transactionType && { transactionType }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate })
    });
    const response = await API.get(`wallet/agent/transactions?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to fetch transactions';
  }
};

// Pay for ITR from wallet
export const payForITR = async (itrId, amount) => {
  try {
    const response = await API.post('/agent/pay-itr', { itrId, amount });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to process payment' };
  }
};

// ===== SUPERADMIN WALLET APIs =====

// Recharge an agent's wallet
export const rechargeAgentWallet = async (agentId, amount, description = '', addToDue = false) => {
  try {
    const response = await API.post('wallet/superadmin/recharge', { agentId, amount, description, addToDue });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to recharge wallet';
  }
};

// Get all agent wallets (superadmin)
export const getAllAgentWallets = async (page = 1, limit = 10) => {
  try {
    const response = await API.get(`wallet/superadmin/wallets?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to fetch agent wallets';
  }
};

// Get specific agent's transactions (superadmin)
export const getAgentWalletTransactions = async (agentId, page = 1, limit = 10, filters = {}) => {
  try {
    const { transactionType, startDate, endDate } = filters;
    const params = new URLSearchParams({
      page,
      limit,
      ...(transactionType && { transactionType }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate })
    });
    // Fix: Add wallet/ prefix which is required based on index.js route mounting
    const response = await API.get(`wallet/superadmin/wallet/${agentId}/transactions?${params.toString()}`);
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to fetch agent transactions';
  }
};
